<template>
  <Section :title="title">
    <div class="grid grid--large grid--multiline">
      <div class="grid__item md-w-1/2">
        <FormGroup
          :field="consumptionField"
          :help="
            light
              ? null
              : gettext('La moyenne Suisse est de 4.76 kg au 100 km.')
          "
          :errors="consumptionErrors"
        >
          <div class="field-group">
            <Input
              v-model="tempConsumptionValue"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <div class="field-group__addon">kg/100 km</div>
          </div>
        </FormGroup>
      </div>
      <div class="grid__item md-w-1/2">
        <FormGroup
          :field="distanceField"
          :help="
            light
              ? null
              : gettext('Le trajet moyen est de 10’370km/an selon l’OFS.')
          "
          :errors="distanceErrors"
        >
          <div class="field-group">
            <Input
              v-model="tempDistanceValue"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <div class="field-group__addon">km</div>
          </div>
        </FormGroup>
      </div>
    </div>
  </Section>
</template>

<script setup>
import Section from '@/components/simulation/Section.vue';
import FormGroup from '@/components/forms/FormGroup.vue';
import Input from '@/components/forms/fields/Input.vue';
import { computed, ref, watch } from 'vue';
import { useSimulation } from '@/composables/useSimulation';

defineProps({
  title: {
    type: String,
    default: gettext('Quelle est votre consommation de gaz naturel-biogaz?'),
  },
  light: {
    type: Boolean,
    default: false,
  },
});

const { simulation, updateSimulation } = useSimulation();

const consumptionErrors = ref([]);
const distanceErrors = ref([]);
const tempDistanceValue = ref(simulation.distance);

const tempConsumptionValue = ref(simulation.mobilityConsumption);

const consumptionField = computed(() => {
  return {
    label: gettext('Consommation moyenne'),
    name: 'consumption',
    required: true,
  };
});

const distanceField = computed(() => {
  return {
    label: gettext('Distance annuelle parcourue'),
    name: 'power',
    required: true,
  };
});

watch(tempConsumptionValue, (value) => {
  consumptionErrors.value = [];
  const val = parseFloat(value);

  /* eslint-disable-next-line eqeqeq */
  if (isNaN(val) || val != value) {
    consumptionErrors.value.push(gettext('Doit être un nombre.'));
    updateSimulation({ mobilityConsumption: null });
    return;
  }
  updateSimulation({ mobilityConsumption: val });
});

watch(tempDistanceValue, (value) => {
  distanceErrors.value = [];
  const val = parseInt(value);

  /* eslint-disable-next-line eqeqeq */
  if (isNaN(val) || val != value) {
    distanceErrors.value.push(gettext('Doit être un nombre.'));
    updateSimulation({ distance: null });
    return;
  }
  updateSimulation({ distance: val });
});
</script>
